export const storyText = {
    links: [
        { href: "https://vc.ru/p/bivan?from=rss", image: "about-us-01.png" },
        { href: "https://lifehacker.ru/bivan-2-0/", image: "about-us-02.png" },
        {
            href: "http://www.rbc.ru/own_business/24/08/2016/57bd50cd9a7947d8552c88f3",
            image: "about-us-03.png",
        },
        {
            href: "https://rg.ru/2016/10/24/v-rossii-stal-populiarnym-kraudfanding-dlia-biznes-idej.html",
            image: "about-us-04.png",
        },
        {
            href: "http://www.popmech.ru/editorial/257252-5-sposobov-ispolzovaniya-bivana/",
            image: "about-us-05.png",
        },
        {
            href: "https://www.youtube.com/watch?v=EjyVjf8qHUQ",
            image: "about-us-06.png",
        },
        {
            href: "http://www.the-village.ru/village/business/news/236575-biz-geek",
            image: "about-us-07.png",
        },
    ],
    features: [
        {
            title: "На траве",
            text: "Можно удобно расположиться на&nbsp;лугу, в&nbsp;парке или на&nbsp;даче",
            image: "grass.png",
        },
        {
            title: "На камнях",
            text: "Лежать на&nbsp;камнях ещё никогда не&nbsp;было так комфортно",
            image: "rocks.png",
        },
        {
            title: "На воде",
            text: "Несколько взмахов и&nbsp;ваш непотопляемый биван готов покорять водную стихию",
            image: "water.png",
        },
        {
            title: "На снегу",
            text: "Биван протестирован в&nbsp;суровых условиях катания с&nbsp;ледяных горок",
            image: "snow.png",
        },
    ],
    team: [
        {
            name: "Николай Белоусов",
            text: "Маркетолог и&nbsp;серийный предприниматель. Основатель Madrobots.ru, и&nbsp;двух брендов, запущенных с&nbsp;помощью краудфандинга&nbsp;&mdash; Zavtra и&nbsp;Биван.",
            image: "team-nb.png",
        },
        {
            name: "Иван Кудрявцев",
            text: "Коммерческий директор. Более 8&nbsp;лет развивал розничную сеть магазинов Студии Лебедева.",
            image: "team-ik.png",
        },
        {
            name: "Евгений Нестёркин",
            text: "Автор идеи и&nbsp;технический директор проекта. Инженер-технолог с&nbsp;серьезным опытом текстильного производства.",
            image: "team-en.png",
        },
    ],
};
